import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/attendance`;

// Toujours récupérer le token au moment de l'appel (pas au load du module)
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    "Content-Type": "application/json",
  };
};

// Utilitaire : force 'YYYY-MM-DD'
const toYMD = (d) => (d ? String(d).slice(0, 10) : "");

/* -------------------------------------------------------
 * POST (bulk upsert)
 * - Enregistre l'appel d'un groupe (crée ou met à jour si existe)
 * - attendances: [{ adherent_id, presence, date_presence }]
 * ----------------------------------------------------- */
export const saveAttendance = async (attendances = []) => {
  try {
    const payload = {
      attendances: attendances.map((a) => ({
        adherent_id: Number(a.adherent_id),
        presence: !!a.presence,
        date_presence: toYMD(a.date_presence),
      })),
    };
    const { data } = await axios.post(`${apiUrl}/submitAttendance`, payload, {
      headers: authHeaders(),
    });
    return data;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de l'appel (bulk):", error?.response?.data || error);
    throw error;
  }
};

/* -------------------------------------------------------
 * PUT (unitaire)
 * - Met à jour 1 case (adherent_id + date) -> presence true/false
 * ----------------------------------------------------- */
export const setAttendance = async (adherentId, date, presence) => {
  try {
    const d = toYMD(date);
    const { data } = await axios.put(
      `${apiUrl}/${adherentId}/${d}`,
      { presence: !!presence },
      { headers: authHeaders() }
    );
    return data;
  } catch (error) {
    console.error("Erreur setAttendance (unitaire):", error?.response?.data || error);
    throw error;
  }
};

/* -------------------------------------------------------
 * DELETE (unitaire)
 * - Supprime 1 case (retire la saisie pour ce jour)
 * ----------------------------------------------------- */
export const clearAttendance = async (adherentId, date) => {
  try {
    const d = toYMD(date);
    const { data } = await axios.delete(`${apiUrl}/${adherentId}/${d}`, {
      headers: authHeaders(),
    });
    return data;
  } catch (error) {
    console.error("Erreur clearAttendance (unitaire):", error?.response?.data || error);
    throw error;
  }
};

/* -------------------------------------------------------
 * GET
 * ----------------------------------------------------- */
export const getAllAttendances = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/getAllAttendances`, {
      headers: authHeaders(),
    });
    return data;
  } catch (error) {
    console.error("Erreur getAllAttendances:", error?.response?.data || error);
    throw error;
  }
};

// Compte présences/absences + % par adhérent
export const countAttendance = async (adherentId) => {
  try {
    const { data } = await axios.get(`${apiUrl}/calculateAssiduity/${adherentId}`, {
      headers: authHeaders(),
    });
    return data;
  } catch (error) {
    console.error("Erreur countAttendance:", error?.response?.data || error);
    throw error;
  }
};

// Liste des appels d'un adhérent
export const getAttendanceList = async (adherentId) => {
  try {
    const { data } = await axios.get(`${apiUrl}/getAttendancesByAdherent/${adherentId}`, {
      headers: authHeaders(),
    });
    return data;
  } catch (error) {
    console.error("Erreur getAttendanceList:", error?.response?.data || error);
    throw error;
  }
};

/* -------------------------------------------------------
 * DELETE (mass)
 * ----------------------------------------------------- */
export const deleteAllAttendances = async () => {
  try {
    const { data } = await axios.delete(`${apiUrl}/deleteAll`, {
      headers: authHeaders(),
    });
    return data;
  } catch (error) {
    console.error("Erreur deleteAllAttendances:", error?.response?.data || error);
    throw error;
  }
};
